import ContractsService from '@/services/API/ContractsService';

export default {
  namespaced: true,
  state: {
    agreement: null,
    enrollment: null,
  },
  getters: {
    isOpened(state) {
      return state.opened;
    },
  },
  actions: {
    GET_AGREEMENT({ commit }) {
      commit('GET_AGREEMENT');
    },
    GET_ENROLLMENT({ commit }) {
      commit('GET_ENROLLMENT');
    },
  },
  mutations: {
    GET_AGREEMENT: async (state) => {
      const { data } = await ContractsService.getAgreementUnreadMessages();
      state.agreement = data.data;
    },
    GET_ENROLLMENT: async (state) => {
      const { data } = await ContractsService.getEnrollmentUnreadMessages();
      state.enrollment = data.data;
    },
  },
};
